import RewardTable from './RewardTable'

export default RewardTable
